import { Operator } from './Operator';
import { CriteriaValue } from '../../../types/AlertConfiguration';

type Field = {
  type: Field.Type;
  name: Field.Name;
  label?: string;
  text?: string;
  filterable?: boolean;
  lineBreak?: boolean;
  options?: Field.Option[] | Field.OptGroup[];
  placeholder?: string;
  defaultValue?: string;
  defaultLabel?: string;
  initialize?: Field.Initialize;
  isVisible?: Field.IsVisible;
  validation?: string;
};

type FieldGroup = {
  type: 'group';
  fields: Field[];
  isVisible?: Field.IsVisible;
};

function isField(ob: Field | FieldGroup): ob is Field {
  return ob.type !== 'group';
}

function isFieldGroup(ob: Field | FieldGroup): ob is FieldGroup {
  return ob.type === 'group';
}

namespace Field {
  export type Ref = { field: Name };
  export type Type = 'input/text' | 'select' | 'multiselect' | 'multiselect/oneline';
  export type Name = keyof CriteriaValue;
  export type Value = string | string[];

  export type Option = {
    value: string;
    label: string;
    title?: string;
  };

  export type OptGroup = {
    label: string;
    options: Option[];
  };

  export type TransformResponse = {
    key?: string;
    mapProperties: { [K: string]: string };
  };

  export type Initializer = {
    url: string;
    method?: 'GET' | 'POST';
    params?: {};
    body?: {};
    transformResponse?: TransformResponse;
  };

  export type Initialize = { options: Initializer };

  export type IsVisible = Operator.Expression | boolean;
}

export type { Field, FieldGroup };
export { isField, isFieldGroup };
